import { Injectable } from "@angular/core";
import {
  BaseFpxDataService,
  CreateFn,
  CriteriaQuery,
  FindAllFn,
  FindByKeyFn,
  HttpProviderService,
  HttpRequest,
  HttpRequestPayload,
  IHttpErrorPayload,
  IHttpSuccessPayload,
  ILookupResponse,
  LookUpFn,
  ModifyFn,
} from "@fpx/core";
import { Observable, catchError, map, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { DepositsDetails } from "../models/deposits.model";
import { DepositsInfo } from "../models/deposits-info.model";
import { CommonService } from "src/app/common.service";

@Injectable({
  providedIn: "root",
})
export class DepositDetailService implements BaseFpxDataService<any> {
  constructor(
    private _httpProvider: HttpProviderService,
    private _commonService: CommonService
  ) {}
  create(payload: DepositsDetails): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("POST");
      httpRequest.setResource("/maturityinstruction");
      let bodyContent = { maturityinstruction: payload };
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.depositsPublisher);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }

  findByKey(key: DepositsDetails): FindByKeyFn<DepositsDetails> {
    return () => {
      return null;
    };
  }

  modify(payload: DepositsDetails): ModifyFn<any> {
    return () => {
      return null;
    };
  }

  findAll(criteriaQuery: CriteriaQuery): FindAllFn<DepositsDetails[]> {
    return () => {
      return null;
    };
  }

  lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("GET");
      httpRequest.setResource("/maturityinstruction");
      httpRequest.addQueryParameter("lookup", 1);
      const httpCriteria = new CriteriaQuery();
      httpCriteria.setPaginationCriteria("1", 10);
      httpCriteria.addFilterCritertia("text", "String", "startsWith", {
        searchText: key.searchText ?? "",
      });
      httpRequest.setCriteriaQuery(httpCriteria);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
  fetchDepositInfo(accountNumber): Observable<DepositsInfo> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource("/deposits/{accountNumber}");
    httpRequest.addPathParameter("accountNumber", accountNumber);
    httpRequest.setMethod("GET");
    httpRequest.setServerContext(environment.depositsPublisher);
    return this._httpProvider
      .invokeRestApi(httpRequest)
      .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.deposits ?? null));
  }

  downloadGICReceipt(accountNumber: string): Observable<any> {
    const httpRequest = new HttpRequest();
    httpRequest.setResource("/depositreceipt");
    httpRequest.setMethod("GET");
    httpRequest.setServerContext(environment.depositsPublisher);
    httpRequest.addQueryParameter("accountNumber", accountNumber);
    this._commonService.showSpinner();
    return this._httpProvider.invokeDownloadApi(httpRequest);
  }
}
